import { useCallback, useEffect, useReducer } from 'react';
import apiClient from '../_utils/axios';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const initialState = {
  data: {
    designList: [],
  },
};

const newDesignReducer = (state, action) => {
  switch (action.type) {
    case 'SET_DATA':
      return {
        ...state,
        data: { ...state.data, ...action.payload },
      };
    case 'RESET':
      return initialState;
    default:
      return state;
  }
};

class NewDesignService {
  async getNewDesign() {
    try {
      const res = await apiClient.get(`/web/newdesignlist`);
      if (res) {
        return {
          designList: res.data.data,
        };
      }
    } catch (error) {
      console.error('Failed to fetch new design list:', error);
      return {
        designList: [],
      };
    }
  }
}

export const useNewDesign = () => {
  const [state, dispatch] = useReducer(newDesignReducer, initialState);
  const history = useHistory();
  const newDesignService = new NewDesignService();

  useEffect(() => {
    const fetchData = async () => {
      const data = await newDesignService.getNewDesign();
      dispatch({ type: 'SET_DATA', payload: data });
    };

    fetchData();
  }, []);

  const actions = {
    setData: useCallback((payload) => {
      dispatch({ type: 'SET_DATA', payload });
    }, []),

    goMoreDesign: useCallback(() => {
      history.push('/design/all/all');
    }, [history]),
  };

  return { state, actions };
};
